const getters = {
  // 获取主题相关
  theme: state => state.theme.theme,
  sideTheme: state => state.theme.sideTheme,
  logoTheme: state => state.theme.logoTheme,
  headerTheme: state => state.theme.headerTheme,

  // 获取用户相关
  name: state => state.user.name,
  phone: state => state.user.phone,
  avatar: state => state.user.avatar,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  level: state => state.user.level,
  // 获取路由相关
  sidebarRouters: state => state.route.sidebarRouters,
  currentRoutes: state => state.route.currentRoutes,

  // 获取tabView
  visitedViewList: state => state.tagsView.visitedViewList,
  // 字典
  injurySigmInGroup: state => state.dict.injurySigmInGroup,
  injurySigmInType: state => state.dict.injurySigmInType,
}
export default getters
